"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoResultsMessage = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'center',
  width: '100%'
});
const NoResults = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(3)
}));
const SearchTerm = (0, _mui.styled)('span')({
  fontWeight: 'bold'
});
const NoResultsMessage = ({
  searchTerm
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(NoResults, {
      variant: "h4",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "noResults"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "thereWereNoResultsForYourInquiry"
      }), ` “`, /*#__PURE__*/(0, _jsxRuntime.jsx)(SearchTerm, {
        ...getTestIdProps(_models.TestId.NoResultsSearchTerm),
        children: searchTerm
      }), "\u201D"]
    })]
  });
};
exports.NoResultsMessage = NoResultsMessage;